<template>
  <!-- 详情 -->
  <el-form ref="form" :model="form" :label-width="labelWidth" :label-position="labelPosition" :id="pageId">
    <div v-for="box in boxList" :key="box.index">
      <div v-if="box.isDesc"  class="descicon"></div>
      <span v-if="box.isDesc"  class="font16">{{box.descTitle}}</span>
      <el-row type="flex" :gutter="30" style="flex-wrap: wrap;margin-top: 20px">
        <el-col :span="item.span" v-for="item in box.formItem" :key="item.index">
          <el-form-item v-if="item.prop == 'accountingInformation'" :label="item.label" :prop="item.prop">
            <div style="display: flex; column-gap: 10px;">
              <span class="clickName" v-if="form.accountingListInfoList && form.accountingListInfoList.length" @click="fileHandle(form.accountingListInfoList,'电子版测试清单')">电子版测试清单</span>
              <span class="clickName" v-if="form.accountingContractInfoList && form.accountingContractInfoList.length" @click="fileHandle(form.accountingContractInfoList,'电子合同')">电子合同</span>
              <span class="clickName" v-if="form.accountingReportInfoList && form.accountingReportInfoList.length" @click="fileHandle(form.accountingReportInfoList,'电子报告')">电子报告</span>
              <span class="clickName" v-if="form.standingbookInfoList && form.standingbookInfoList.length" @click="fileHandle(form.standingbookInfoList,'对账单')">对账单</span>
              <span class="clickName" v-if="form.accountingOtherInfoList && form.accountingOtherInfoList.length" @click="fileHandle(form.accountingOtherInfoList,'其他资料')">其他资料</span>
            </div>
          </el-form-item>
          <el-form-item v-else :label="item.label" :prop="item.prop">
            <span class="defaultClass">{{form[item.prop] || '-'}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </el-form>
</template>
<script>
export default {
  props: {
    boxList: {
      type: [Array, Object],
      default: () => {
        return [];
      }
    },
    form: {
      type: [Array, Object],
      default: () => {
        return {};
      }
    },
    labelWidth: {
      type: String,
      default: "120px"
    },
    pageId: {
      type: String,
      default: "personalItem"
    },
    labelPosition: {
      type: String,
      default: "left"
    }
  },

  data() {
    return {};
  },
  methods: {
    fileHandle(list,name) {
      if (list.length > 0) {
        let obj = {
          businessName: name,
          businessIds: list.map(item => item.fileId).toString(),
          businessType: 2
        }
        this.$download.getDownLoadXls('/file/communal/download/fileZipDownload', obj)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>